import Lieu from '@/generated/classes/Lieu';
export default class LieuExtend extends Lieu {
  constructor() {
    super();
  }
}
